module.exports = __webpack_public_path__ + "img/UY.916f66e3.svg";